import editableDate from "./editableDate.component";

const editableDateModule = angular
  .module("app.components.editableDate", [])
  .component("editableDate", editableDate);

export default editableDateModule;



// WEBPACK FOOTER //
// ./src/components/editableDate/editableDate.module.js